export default __webpack_public_path__ + "static/media/blueFontLogo.aab3abb6.jpeg";